export class UIManager {
  constructor() {
    this.gameLogic = null;
    this.levelCompleteCallback = null;
    this.soundManager = null;
    this.mandalaRotation = 0;
    this.totalScore = 0;
    this.createUI();
  }

  setSoundManager(soundManager) {
    this.soundManager = soundManager;
  }

  setGameLogic(gameLogic) {
    this.gameLogic = gameLogic;
  }

  setLevelCompleteCallback(callback) {
    this.levelCompleteCallback = callback;
  }

  onLevelComplete() {
    // Play level complete sound
    if (this.soundManager) {
      this.soundManager.playComplete();
    }

    // Show level complete UI and call callback
    if (this.levelCompleteCallback) {
      this.levelCompleteCallback();
    }
  }

  showMessage(message, type = "info", details = null) {
    console.log("showMessage called with type:", type);

    // Remove any existing message
    const existingMessage = document.querySelector(".game-message");
    if (existingMessage) {
      document.body.removeChild(existingMessage);
    }

    const messageElement = document.createElement("div");
    messageElement.className = "game-message";
    messageElement.style.cssText = `
      position: fixed;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background: rgba(0, 0, 0, 0.8);
      color: white;
      padding: 20px;
      border-radius: 10px;
      text-align: center;
      z-index: 1000;
      max-width: 80%;
      font-family: "Philosopher", sans-serif;
      backdrop-filter: blur(5px);
    `;

    // Create header
    const header = document.createElement("h2");
    header.textContent = message;
    header.style.margin = "0 0 20px 0";
    messageElement.appendChild(header);

    if (type === "welcome") {
      console.log("Creating welcome message with start button");
      // Add start button
      const startButton = document.createElement("button");
      startButton.className = "game-button";
      startButton.textContent = "Start Game";
      startButton.style.padding = "15px 30px";
      startButton.onclick = () => {
        console.log("Start Game button clicked");
        document.body.removeChild(messageElement);
        if (this.gameLogic) {
          console.log("Starting level 1");
          this.gameLogic.startLevel(1);
          console.log("Setting up tutorial gesture");
          // Wait for level to be fully loaded
          requestAnimationFrame(() => {
            console.log("Level loaded, scheduling tutorial");
            setTimeout(() => {
              console.log("Showing tutorial gesture");
              this.showTutorialGesture();
            }, 1000);
          });
        }
      };
      messageElement.appendChild(startButton);
    } else if (type === "levelComplete" && details) {
      // Show level complete stats
      const stats = document.createElement("div");
      stats.style.marginBottom = "20px";
      stats.innerHTML = `
        <div style="margin: 10px 0;">Level Score: ${details.levelScore}</div>
        <div style="margin: 10px 0;">Total Score: ${details.totalScore}</div>
        <div style="margin: 10px 0;">Moves Used: ${details.moves}/${details.maxMoves}</div>
        <div style="margin: 10px 0;">Negative Crystals Cleared: ${details.negativeCrystalsRemoved}</div>
        <div style="margin: 10px 0;">Energy Collected: ${details.energy}/${details.maxEnergy}</div>
        <div style="margin: 10px 0;">Connections Made: ${details.connectionsMade}/${details.requiredConnections}</div>
      `;
      messageElement.appendChild(stats);

      // Update total score
      this.totalScore = details.totalScore;

      // Add continue button
      const continueButton = document.createElement("button");
      continueButton.className = "game-button";
      continueButton.textContent = "Continue to Next Level";
      continueButton.style.padding = "15px 30px";
      continueButton.onclick = () => {
        document.body.removeChild(messageElement);
        if (this.gameLogic) {
          this.gameLogic.nextLevel();
        }
      };
      messageElement.appendChild(continueButton);
    } else if (type === "phaseComplete" && details) {
      // Show phase completion stats
      const stats = document.createElement("div");
      stats.style.marginBottom = "20px";
      stats.innerHTML = `
        <div style="margin: 10px 0;"><i class="fas fa-star" style="color: #FFD700"></i> Phase ${details.phase} Complete! <i class="fas fa-star" style="color: #FFD700"></i></div>
        <div style="margin: 10px 0;">Total Score: ${details.totalScore}</div>
        <div style="margin: 10px 0;">Get ready for new chakra combinations!</div>
      `;
      messageElement.appendChild(stats);

      // Update total score
      this.totalScore = details.totalScore;

      // Add continue button
      const continueButton = document.createElement("button");
      continueButton.className = "game-button";
      continueButton.textContent = "Start Next Phase";
      continueButton.style.cssText = `
        padding: 8px 12px;
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 40px;
      `;
      continueButton.onclick = () => {
        document.body.removeChild(messageElement);
        // If we're already on the first level of the next phase, just close the dialog
        if (this.gameLogic && this.gameLogic.getLevelInPhase() === 1) {
          // Do nothing, just close the dialog
          console.log(
            "Already on first level of next phase, just closing dialog"
          );
        } else if (this.gameLogic) {
          this.gameLogic.nextLevel();
        }
      };
      messageElement.appendChild(continueButton);
    } else if (type === "gameOver" && details) {
      // Show game over stats
      const stats = document.createElement("div");
      stats.style.marginBottom = "20px";
      stats.innerHTML = `
        <div style="margin: 10px 0;">Phase: ${details.phase}</div>
        <div style="margin: 10px 0;">Level: ${details.level}</div>
        <div style="margin: 10px 0;">Score: ${details.score}</div>
        <div style="margin: 10px 0;">Total Score: ${details.totalScore}</div>
        <div style="margin: 10px 0;">Moves Used: ${details.moves}/${details.maxMoves}</div>
        <div style="margin: 10px 0;">Negative Crystals Cleared: ${details.negativeCrystalsRemoved}</div>
        <div style="margin: 10px 0;">Energy Collected: ${details.energy}/${details.maxEnergy}</div>
        <div style="margin: 10px 0;">Connections Made: ${details.connectionsMade}/${details.requiredConnections}</div>
      `;
      messageElement.appendChild(stats);

      // Add retry button
      const retryButton = document.createElement("button");
      retryButton.className = "game-button";
      retryButton.textContent = "Retry Level";
      retryButton.style.padding = "15px 30px";
      retryButton.onclick = () => {
        document.body.removeChild(messageElement);
        if (this.gameLogic) {
          this.gameLogic.startLevel(this.gameLogic.currentLevel);
        }
      };
      messageElement.appendChild(retryButton);
    } else if (type === "info") {
      // For regular messages, auto-dismiss after 2 seconds
      setTimeout(() => {
        messageElement.style.animation = "tutorialFadeOut 0.5s ease-in-out";
        setTimeout(() => {
          if (messageElement.parentNode) {
            document.body.removeChild(messageElement);
          }
        }, 500);
      }, 2000);
    }

    document.body.appendChild(messageElement);
  }

  updateGameState(gameState) {
    // Update desktop display
    this.desktopScoreDisplay.textContent = `Score: ${gameState.score}`;
    this.desktopTotalScoreDisplay.textContent = `Total: ${
      this.totalScore + gameState.score
    }`;
    this.desktopMovesDisplay.innerHTML = `<i class="fas fa-shoe-prints"></i> ${gameState.moves}/${gameState.maxMoves}`;
    this.desktopLevelDisplay.textContent = `Phase ${gameState.phase} - Level ${gameState.level}`;
    this.desktopEnergyGoal.innerHTML = `<i class="fas fa-bolt"></i> ${gameState.energy}/${gameState.goals.energyToCollect}`;
    this.desktopCrystalGoal.innerHTML = `<i class="fas fa-diamond"></i> ${gameState.negativeCrystalsRemoved}/${gameState.goals.negativeCrystalsToRemove}`;

    // Update mobile display
    this.mobileScoreDisplay.textContent = `Score: ${gameState.score}`;
    this.mobileTotalScoreDisplay.textContent = `Total: ${
      this.totalScore + gameState.score
    }`;
    this.mobileMovesDisplay.innerHTML = `<i class="fas fa-shoe-prints"></i> ${gameState.moves}/${gameState.maxMoves}`;
    this.mobileLevelDisplay.textContent = `Phase ${gameState.phase} - Level ${gameState.level}`;
    this.mobileEnergyGoal.innerHTML = `<i class="fas fa-bolt"></i> ${gameState.energy}/${gameState.goals.energyToCollect}`;
    this.mobileCrystalGoal.innerHTML = `<i class="fas fa-diamond"></i> ${gameState.negativeCrystalsRemoved}/${gameState.goals.negativeCrystalsToRemove}`;

    // Create connection requirement text
    let connectionText = "";
    if (gameState.activeChakras) {
      if (gameState.activeChakras.length === 1) {
        const chakra = gameState.activeChakras[0];
        const chakraColor = this.getChakraColor(chakra);
        connectionText = `<i class="fas fa-diamond" style="color: ${chakraColor}; text-shadow: 0 0 5px rgba(255, 255, 255, 0.5); vertical-align: middle; font-size: 1em"></i> <i class="fas fa-arrow-right" style="font-size: 1em; vertical-align: middle"></i> <i class="fas fa-diamond" style="color: ${chakraColor}; text-shadow: 0 0 5px rgba(255, 255, 255, 0.5); vertical-align: middle; font-size: 1em"></i>`;
      } else if (gameState.activeChakras.length === 2) {
        const chakra1 = gameState.activeChakras[0];
        const chakra2 = gameState.activeChakras[1];
        connectionText = `<i class="fas fa-diamond" style="color: ${this.getChakraColor(
          chakra1
        )}; text-shadow: 0 0 5px rgba(255, 255, 255, 0.5); vertical-align: middle; font-size: 1em"></i> <i class="fas fa-arrow-right" style="font-size: 1em; vertical-align: middle"></i> <i class="fas fa-diamond" style="color: ${this.getChakraColor(
          chakra2
        )}; text-shadow: 0 0 5px rgba(255, 255, 255, 0.5); vertical-align: middle; font-size: 1em"></i>`;
      } else {
        connectionText = gameState.activeChakras
          .map(
            (chakra) =>
              `<i class="fas fa-diamond" style="color: ${this.getChakraColor(
                chakra
              )}; text-shadow: 0 0 5px rgba(255, 255, 255, 0.5); vertical-align: middle; font-size: 1em"></i>`
          )
          .join(
            ` <i class="fas fa-arrow-right" style="font-size: 1em; vertical-align: middle"></i> `
          );
      }
    }

    // Update both desktop and mobile connection displays
    const connectionStats = `${connectionText} <span style="vertical-align: middle; font-size: 1em; letter-spacing: 3px">${gameState.connectionsMade}/${gameState.goals.connectionsRequired}</span>`;
    this.desktopConnectionDisplay.innerHTML = connectionStats;
    this.mobileConnectionDisplay.innerHTML = connectionStats;
  }

  // Helper function to get chakra colors in hex
  getChakraColor(chakra) {
    const chakraColors = {
      // The 7 chakras in order from root to crown
      red: "#FF0000", // Muladhara (Root Chakra)
      orange: "#FF8C00", // Svadhishthana (Sacral Chakra)
      yellow: "#FFFF00", // Manipura (Solar Plexus Chakra)
      green: "#00FF00", // Anahata (Heart Chakra)
      blue: "#00FFFF", // Vishuddha (Throat Chakra)
      indigo: "#0000FF", // Ajna (Third Eye Chakra)
      purple: "#FF00FF", // Sahasrara (Crown Chakra)
    };
    return chakraColors[chakra] || "#ffffff";
  }

  // Helper function to get complementary glow color
  getGlowColor(chakra) {
    const glowColors = {
      red: "rgba(255, 0, 0, 0.8)", // Red glow
      orange: "rgba(255, 140, 0, 0.8)", // Orange glow
      yellow: "rgba(255, 255, 0, 0.8)", // Yellow glow
      green: "rgba(0, 255, 0, 0.8)", // Green glow
      blue: "rgba(0, 255, 255, 0.8)", // Blue glow
      indigo: "rgba(0, 0, 255, 0.8)", // Indigo glow
      purple: "rgba(255, 0, 255, 0.8)", // Purple glow
    };
    return glowColors[chakra] || "rgba(255, 255, 255, 0.8)";
  }

  createUI() {
    // Create desktop layout
    const desktopPanel = document.createElement("div");
    desktopPanel.className = "top-panel desktop-panel";

    // Desktop level title (left)
    this.desktopLevelDisplay = document.createElement("div");
    this.desktopLevelDisplay.className = "level-title";
    this.desktopLevelDisplay.textContent = "Phase 1 - Level 1";

    // Desktop stats row (center)
    const desktopStatsRow = document.createElement("div");
    desktopStatsRow.className = "stats-row";

    // Desktop moves display
    this.desktopMovesDisplay = document.createElement("div");
    this.desktopMovesDisplay.className = "stats-item moves-display";
    this.desktopMovesDisplay.innerHTML =
      '<i class="fas fa-shoe-prints"></i> 0/30';

    // Desktop energy goal
    this.desktopEnergyGoal = document.createElement("div");
    this.desktopEnergyGoal.className = "stats-item energy-goal";
    this.desktopEnergyGoal.innerHTML = '<i class="fas fa-bolt"></i> 0/30';

    // Desktop negative crystals goal
    this.desktopCrystalGoal = document.createElement("div");
    this.desktopCrystalGoal.className = "stats-item crystal-goal";
    this.desktopCrystalGoal.innerHTML = '<i class="fas fa-diamond"></i> 0/3';

    // Desktop connection goal
    this.desktopConnectionGoal = document.createElement("div");
    this.desktopConnectionGoal.className = "stats-item connection-goal";
    this.desktopConnectionDisplay = document.createElement("div");
    this.desktopConnectionDisplay.className = "connection-display";
    this.desktopConnectionGoal.appendChild(this.desktopConnectionDisplay);

    // Add all desktop stats
    desktopStatsRow.appendChild(this.desktopMovesDisplay);
    desktopStatsRow.appendChild(this.desktopEnergyGoal);
    desktopStatsRow.appendChild(this.desktopCrystalGoal);
    desktopStatsRow.appendChild(this.desktopConnectionGoal);

    // Desktop score section (right)
    const desktopScoreWrapper = document.createElement("div");
    desktopScoreWrapper.className = "score-wrapper";

    this.desktopTotalScoreDisplay = document.createElement("div");
    this.desktopTotalScoreDisplay.className = "total-score-display";
    this.desktopTotalScoreDisplay.textContent = "Total: 0";

    this.desktopScoreDisplay = document.createElement("div");
    this.desktopScoreDisplay.className = "score-display";
    this.desktopScoreDisplay.textContent = "Score: 0";

    desktopScoreWrapper.appendChild(this.desktopTotalScoreDisplay);
    desktopScoreWrapper.appendChild(this.desktopScoreDisplay);

    // Add all desktop sections
    desktopPanel.appendChild(this.desktopLevelDisplay);
    desktopPanel.appendChild(desktopStatsRow);
    desktopPanel.appendChild(desktopScoreWrapper);

    // Create mobile layout
    const mobilePanel = document.createElement("div");
    mobilePanel.className = "top-panel mobile-panel";

    // Mobile header row (level and score)
    const mobileHeaderRow = document.createElement("div");
    mobileHeaderRow.className = "header-row";

    this.mobileLevelDisplay = document.createElement("div");
    this.mobileLevelDisplay.className = "level-title";
    this.mobileLevelDisplay.textContent = "Phase 1 - Level 1";

    const mobileScoreWrapper = document.createElement("div");
    mobileScoreWrapper.className = "score-wrapper";

    this.mobileTotalScoreDisplay = document.createElement("div");
    this.mobileTotalScoreDisplay.className = "total-score-display";
    this.mobileTotalScoreDisplay.textContent = "Total: 0";

    this.mobileScoreDisplay = document.createElement("div");
    this.mobileScoreDisplay.className = "score-display";
    this.mobileScoreDisplay.textContent = "Score: 0";

    mobileScoreWrapper.appendChild(this.mobileTotalScoreDisplay);
    mobileScoreWrapper.appendChild(this.mobileScoreDisplay);

    mobileHeaderRow.appendChild(this.mobileLevelDisplay);
    mobileHeaderRow.appendChild(mobileScoreWrapper);

    // Mobile stats row
    const mobileStatsRow = document.createElement("div");
    mobileStatsRow.className = "stats-row";

    this.mobileMovesDisplay = document.createElement("div");
    this.mobileMovesDisplay.className = "stats-item moves-display";
    this.mobileMovesDisplay.innerHTML =
      '<i class="fas fa-shoe-prints"></i> 0/30';

    this.mobileEnergyGoal = document.createElement("div");
    this.mobileEnergyGoal.className = "stats-item energy-goal";
    this.mobileEnergyGoal.innerHTML = '<i class="fas fa-bolt"></i> 0/30';

    this.mobileCrystalGoal = document.createElement("div");
    this.mobileCrystalGoal.className = "stats-item crystal-goal";
    this.mobileCrystalGoal.innerHTML = '<i class="fas fa-diamond"></i> 0/3';

    mobileStatsRow.appendChild(this.mobileMovesDisplay);
    mobileStatsRow.appendChild(this.mobileEnergyGoal);
    mobileStatsRow.appendChild(this.mobileCrystalGoal);

    // Mobile connection row
    const mobileConnectionRow = document.createElement("div");
    mobileConnectionRow.className = "connection-row";

    this.mobileConnectionGoal = document.createElement("div");
    this.mobileConnectionGoal.className = "connection-goal";
    this.mobileConnectionDisplay = document.createElement("div");
    this.mobileConnectionDisplay.className = "connection-display";
    this.mobileConnectionGoal.appendChild(this.mobileConnectionDisplay);

    mobileConnectionRow.appendChild(this.mobileConnectionGoal);

    // Add all mobile sections
    mobilePanel.appendChild(mobileHeaderRow);
    mobilePanel.appendChild(mobileStatsRow);
    mobilePanel.appendChild(mobileConnectionRow);

    // Add both layouts to the document
    document.body.appendChild(desktopPanel);
    document.body.appendChild(mobilePanel);

    // Create bottom controls and other UI elements
    this.createBottomControls();
    this.createDialogs();
  }

  setupDialogs() {
    // Audio Settings Dialog
    const audioDialog = document.getElementById("audio-settings");
    const musicToggle = document.getElementById("music-toggle");
    const musicVolume = document.getElementById("music-volume");
    const sfxToggle = document.getElementById("sfx-toggle");
    const sfxVolume = document.getElementById("sfx-volume");

    // Set up audio control event listeners
    musicToggle.addEventListener("change", () => {
      const settings = this.getAudioSettings();
      settings.musicEnabled = musicToggle.checked;
      this.saveAudioSettings(settings);
      this.applyAudioSettings();
    });

    musicVolume.addEventListener("input", () => {
      const settings = this.getAudioSettings();
      settings.musicVolume = parseInt(musicVolume.value) / 100;
      this.saveAudioSettings(settings);
      this.applyAudioSettings();
    });

    sfxToggle.addEventListener("change", () => {
      const settings = this.getAudioSettings();
      settings.sfxEnabled = sfxToggle.checked;
      this.saveAudioSettings(settings);
      this.applyAudioSettings();
    });

    sfxVolume.addEventListener("input", () => {
      const settings = this.getAudioSettings();
      settings.sfxVolume = parseInt(sfxVolume.value) / 100;
      this.saveAudioSettings(settings);
      this.applyAudioSettings();
    });

    // Close dialog buttons
    document.querySelectorAll(".close-dialog").forEach((button) => {
      button.addEventListener("click", () => {
        document.querySelectorAll(".dialog").forEach((dialog) => {
          dialog.classList.remove("show");
        });
      });
    });
  }

  showAudioSettings() {
    const dialog = document.getElementById("audio-settings");
    dialog.classList.add("show");
  }

  showHelp() {
    const dialog = document.getElementById("help-dialog");
    dialog.classList.add("show");
  }

  getAudioSettings() {
    const defaultSettings = {
      musicEnabled: true,
      musicVolume: 0.5,
      sfxEnabled: true,
      sfxVolume: 0.5,
    };

    const savedSettings = localStorage.getItem("audioSettings");
    return savedSettings ? JSON.parse(savedSettings) : defaultSettings;
  }

  saveAudioSettings(settings) {
    localStorage.setItem("audioSettings", JSON.stringify(settings));
  }

  loadAudioSettings() {
    const settings = this.getAudioSettings();

    // Update UI elements
    document.getElementById("music-toggle").checked = settings.musicEnabled;
    document.getElementById("music-volume").value = settings.musicVolume * 100;
    document.getElementById("sfx-toggle").checked = settings.sfxEnabled;
    document.getElementById("sfx-volume").value = settings.sfxVolume * 100;

    // Apply settings
    this.applyAudioSettings();
  }

  applyAudioSettings() {
    if (!this.soundManager) return;

    const settings = this.getAudioSettings();

    // Apply music settings
    this.soundManager.sounds.background.volume = settings.musicEnabled
      ? settings.musicVolume
      : 0;

    // Apply SFX settings
    ["tap", "connection", "connected", "complete"].forEach((sound) => {
      this.soundManager.sounds[sound].volume = settings.sfxEnabled
        ? settings.sfxVolume
        : 0;
    });
  }

  createEnergyMeter() {
    /* // Create energy meter container
    const energyMeterContainer = document.createElement("div");
    energyMeterContainer.id = "energy-meter";
    energyMeterContainer.style.cssText = `
      position: absolute;
      top: 10px;
      left: 50%;
      transform: translateX(-50%);
      width: 120px;
      height: 120px;
      pointer-events: none;
    `;

    // Create SVG for mandala
    const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    svg.setAttribute("viewBox", "0 0 200 200");
    svg.style.width = "100%";
    svg.style.height = "100%";

    // Create mandala patterns
    const mandala = document.createElementNS("http://www.w3.org/2000/svg", "g");

    // Create circular patterns
    for (let i = 0; i < 8; i++) {
      const circle = document.createElementNS(
        "http://www.w3.org/2000/svg",
        "circle"
      );
      circle.setAttribute("cx", "100");
      circle.setAttribute("cy", "100");
      circle.setAttribute("r", 80 - i * 10);
      circle.setAttribute("fill", "none");
      circle.setAttribute("stroke", "rgba(255, 255, 255, 0.2)");
      circle.setAttribute("stroke-width", "1");
      mandala.appendChild(circle);
    }

    // Create petals
    for (let i = 0; i < 12; i++) {
      const petal = document.createElementNS(
        "http://www.w3.org/2000/svg",
        "path"
      );
      const angle = (i * 30 * Math.PI) / 180;
      const x1 = 100 + Math.cos(angle) * 40;
      const y1 = 100 + Math.sin(angle) * 40;
      const x2 = 100 + Math.cos(angle) * 80;
      const y2 = 100 + Math.sin(angle) * 80;

      petal.setAttribute("d", `M ${x1} ${y1} L ${x2} ${y2}`);
      petal.setAttribute("stroke", "rgba(255, 255, 255, 0.2)");
      petal.setAttribute("stroke-width", "1");
      mandala.appendChild(petal);
    }

    svg.appendChild(mandala);
    energyMeterContainer.appendChild(svg);
    document.body.appendChild(energyMeterContainer);
    this.energyMeter = mandala; */
  }

  updateEnergyMeter(energyPercentage) {
    /* if (!this.energyMeter) return;

    // Rotate mandala based on energy level
    this.mandalaRotation += energyPercentage * 2;
    this.energyMeter.style.transform = `rotate(${this.mandalaRotation}deg)`;

    // Update mandala glow intensity
    const glowIntensity = Math.min(20, energyPercentage * 20);
    this.energyMeter.style.filter = `drop-shadow(0 0 ${glowIntensity}px rgba(255, 255, 255, 0.5))`;

    // Update mandala opacity based on energy
    const circles = this.energyMeter.querySelectorAll("circle");
    const paths = this.energyMeter.querySelectorAll("path");
    const elements = [...circles, ...paths];

    elements.forEach((element, index) => {
      const baseOpacity = 0.2;
      const energyOpacity = energyPercentage * 0.8;
      const finalOpacity = baseOpacity + energyOpacity;
      element.style.stroke = `rgba(255, 255, 255, ${finalOpacity})`;
    }); */
  }

  setLevelCompleteCallback(callback) {
    this.onContinueCallback = callback;
  }

  setGame(game) {
    this.game = game;
  }

  showTutorialGesture() {
    console.log("showTutorialGesture called");
    console.log("gameLogic:", this.gameLogic);
    console.log("currentPhase:", this.gameLogic?.currentPhase);
    console.log("tutorialGesture element:", this.tutorialGesture);

    // Only show tutorial if we're in phase 1, level 1
    if (
      this.gameLogic &&
      this.gameLogic.currentPhase === 1 &&
      this.gameLogic.currentLevel === 1
    ) {
      console.log("Conditions met, adding animate class");
      // Add animate class to start the animation
      this.tutorialGesture.classList.add("animate");
      console.log("Current classes:", this.tutorialGesture.className);

      // Remove the animation class after it completes (3 swipes * 2s each)
      setTimeout(() => {
        console.log("Animation complete, removing animate class");
        this.tutorialGesture.classList.remove("animate");
        // The CSS will automatically stop the guidance pulse when animate class is removed
      }, 6000);
    } else {
      console.log("Conditions not met for showing tutorial");
    }
  }

  createBottomControls() {
    // Create bottom left controls
    const bottomControls = document.createElement("div");
    bottomControls.className = "bottom-controls";

    // Show Hints button
    const hintsButton = document.createElement("button");
    hintsButton.className = "game-button hints-button";
    hintsButton.innerHTML = '<i class="fa-solid fa-lightbulb"></i> Hints On';

    // Skip Level button
    const skipButton = document.createElement("button");
    skipButton.className = "game-button skip-button";
    skipButton.innerHTML = '<i class="fas fa-forward"></i> Skip';
    skipButton.onclick = () => {
      if (this.gameLogic) {
        this.gameLogic.nextLevel();
      }
    };

    bottomControls.appendChild(hintsButton);
    bottomControls.appendChild(skipButton);
    document.body.appendChild(bottomControls);

    // Create game controls (bottom right)
    const controls = document.createElement("div");
    controls.className = "game-controls";

    // Audio settings button
    const audioButton = document.createElement("button");
    audioButton.className = "control-button";
    audioButton.innerHTML = '<i class="fas fa-volume-high"></i>';
    audioButton.onclick = () => {
      const dialog = document.getElementById("audio-settings");
      if (dialog) dialog.classList.add("show");
    };

    // 3D controls toggle button
    const orbitButton = document.createElement("button");
    orbitButton.className = "control-button disabled";
    orbitButton.innerHTML = '<i class="fas fa-up-down-left-right"></i>';
    orbitButton.title = "Toggle 3D Movement";
    orbitButton.onclick = () => {
      const newState = orbitButton.classList.contains("disabled");
      orbitButton.classList.toggle("disabled");
      if (this.game) {
        this.game.toggleOrbitControls(newState);
      }
    };

    // Help button
    const helpButton = document.createElement("button");
    helpButton.className = "control-button";
    helpButton.innerHTML = '<i class="fas fa-question"></i>';
    helpButton.onclick = () => {
      const dialog = document.getElementById("help-dialog");
      if (dialog) dialog.classList.add("show");
    };

    controls.appendChild(audioButton);
    controls.appendChild(orbitButton);
    controls.appendChild(helpButton);
    document.body.appendChild(controls);

    // Create hints checkbox functionality
    let hintsEnabled = true;
    hintsButton.onclick = () => {
      hintsEnabled = !hintsEnabled;
      hintsButton.innerHTML = hintsEnabled
        ? '<i class="fa-solid fa-lightbulb"></i> Hints On'
        : '<i class="fa-regular fa-lightbulb"></i> Hints Off';
      if (this.gameLogic && this.gameLogic.inputHandler) {
        this.gameLogic.inputHandler.debugMode = hintsEnabled;
        if (!hintsEnabled) {
          this.gameLogic.inputHandler.clearValidMoveHighlights();
        }
      }
    };
  }

  createDialogs() {
    // Create audio settings dialog
    const audioDialog = document.createElement("div");
    audioDialog.id = "audio-settings";
    audioDialog.className = "dialog";
    audioDialog.innerHTML = `
      <div class="dialog-content">
        <h2>Audio Settings</h2>
        <div class="settings-group">
          <label>
            <input type="checkbox" id="music-toggle" checked>
            Music
          </label>
          <input type="range" id="music-volume" min="0" max="100" value="50">
        </div>
        <div class="settings-group">
          <label>
            <input type="checkbox" id="sfx-toggle" checked>
            Sound Effects
          </label>
          <input type="range" id="sfx-volume" min="0" max="100" value="50">
        </div>
        <button class="close-dialog">Close</button>
      </div>
    `;
    document.body.appendChild(audioDialog);

    // Create help dialog
    const helpDialog = document.createElement("div");
    helpDialog.id = "help-dialog";
    helpDialog.className = "dialog";
    helpDialog.innerHTML = `
      <div class="dialog-content">
        <h2>How to Play</h2>
        <div class="help-content">
          <p>Connect matching chakras to create energy flows and complete the connection goal shown at the top.</p>
          <p>Clear negative crystals (black diamonds) and collect energy bolts to achieve all level goals.</p>
          <p>Complete each level within the move limit to progress!</p>
          <p>Progress through phases to unlock new chakra combinations and challenges.</p>
        </div>
        <button class="close-dialog">Close</button>
      </div>
    `;
    document.body.appendChild(helpDialog);

    // Set up dialog event listeners
    this.setupDialogs();
  }
}
